import { keyframes } from 'styled-components';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

const loadingImageKeyframes = keyframes`
  0% {
    transform: scaleY(2);
  }
`;

const LoadingImageItem = styled.div`
  ${tw`w-[6px] h-[16px] bg-[#cdd2da]`}
  animation: ${loadingImageKeyframes} 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite
`;

export const LoadingImage = () => (
  <div tw="flex justify-center items-center self-center gap-[4px] w-5 h-5 m-[20px auto]" title="loading">
    <LoadingImageItem />
    <LoadingImageItem css={{ animationDelay: '120ms' }} />
    <LoadingImageItem css={{ animationDelay: '240ms' }} />
  </div>
);
